export function generateColor(input: number): string {
  // Ensure the input is within the range of 0 to 30
  const scaledInput = Math.max(0, Math.min(30, Math.floor(input)));

  const colors = [
    "#e02424", // Darker Shade of Green
    "#f9010b", // Lighter Shade of Green
   "#7e3af3", // Lime Green
    "#fd02ce", // Mint Green
     // Deep Green
    "#ff8b1e",
    "#2170e7", // Pale Green
    "#358c0a", // Seafoam Green
    "#ec9b3b", // Light Mint Green
    "#375D4A", // Dark Moss Green
    "#3A7D44", // Medium Green
    "#A2D5AB", // Soft Green
    "#73C6B6", // Aquamarine
    "#66CC99", // Pastel Green
    "#98FF98", // Mint Green
    "#A8E6CF", // Light Pastel Green
    "#379683", // Cadet Green
    "#8EE4AF", // Light Green
    "#5CDB95", // Medium Spring Green
    "#379683", // Slightly Darker Spring Green
    "#B4CFB0", // Pale Olive Green
    "#F7FFF7", // Very Pale Mint Green
    "#BFFCC6", // Very Light Green
    "#AFF8DB", // Light Teal Green
    "#85E085", // Medium Light Green
    "#99E699", // Soft Light Green
    "#ADEBAD", // Light Pastel Green
    "#247E59", // Cadet Blue (Complementary Color)
    "#247E59", // Steel Blue (Analogous Color)
    "#444", // Medium Slate Blue (Complementary Color)
    "#000", // Slate Blue (Analogous Color)
  ];

  return colors[scaledInput];
}

export const activityTypes = {
  shop: {color: "#678FF9"},
  sightseeing: "#9061F9",
  nightlife: "#F99267",
  cafe: "#F99267",
  food: "#F99267",
  restaurant: "#F99267",
};
